import { render, staticRenderFns } from "./emergencies.vue?vue&type=template&id=4d91656e&scoped=true&"
import script from "./emergencies.vue?vue&type=script&lang=js&"
export * from "./emergencies.vue?vue&type=script&lang=js&"
import style0 from "./emergencies.vue?vue&type=style&index=0&id=4d91656e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91656e",
  null
  
)

export default component.exports